import {FormInputInteger, FormMapCoordinates} from "base/component/form";

const SistemaFormLocationFields = ({orientation = "vertical"}) => {
    return <>{/*<FormMapCoordinates name="geom" orientation={orientation} />*/}</>;
};

export default SistemaFormLocationFields;
